import { Component, Inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { AddProfileDialogComponent } from "../add-profile-dialog/add-profile-dialog.component";

export interface ProfileData {
  profile: string;
  // originators: string;
  read: boolean;
  create: boolean;
  update: boolean;
  decommission: boolean;
  mandatory: boolean;
}

@Component({
  selector: "app-feature-access-rights",
  templateUrl: "./feature-access-rights.component.html",
  styleUrl: "./feature-access-rights.component.scss",
})
export class FeatureAccessRightsComponent {
  displayedColumns: string[] = [
    "profile",
    "read",
    "create",
    "update",
    "decommission",
  ];

  dataSource: ProfileData[] = [
    {
      profile: "Default with OTHER co...",
      // originators: 'AIS Office',
      read: false,
      create: false,
      update: false,
      decommission: false,
      mandatory: false,
    },
    {
      profile: "MET",
      // originators: 'MET Office LQSA',
      read: false,
      create: false,
      update: false,
      decommission: false,
      mandatory: undefined,
    },
    {
      profile: "Other profiles",
      // originators: 'MET Office LQSA',
      read: false,
      create: false,
      update: false,
      decommission: false,
      mandatory: undefined,
    },
  ];

  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<FeatureAccessRightsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { feature: string }
  ) {}

  onClose(): void {
    this.dialogRef.close();
  }

  onLock(): void {
    console.log("Saved data:", this.dataSource);
    this.dialogRef.close(this.dataSource);
  }

  toggleRead(element: ProfileData): void {
    element.read = !element.read;
    if (!element.read) {
      element.create = false;
      element.update = false;
      element.decommission = false;
    }
  }

  toggleCreate(element: ProfileData): void {
    element.create = !element.create;
    if (element.create) {
      element.read = true;
    }
  }

  toggleUpdate(element: ProfileData): void {
    element.update = !element.update;
    if (element.update) {
      element.read = true;
    }
  }

  toggleDecommission(element: ProfileData): void {
    element.decommission = !element.decommission;
    if (element.decommission) {
      element.read = true;
    }
  }
  //   openAddProfileDialog(): void {
  //   const dialogRef = this.dialog.open(AddProfileDialogComponent, {
  //     width: '400px',
  //     data: {  }
  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     if (result) {
  //       console.log('Odabrani profil:', result);
  //     }
  //   });
  // }

  openAddProfileDialog(): void {
    const dialogRef = this.dialog.open(AddProfileDialogComponent, {
      width: "400px",
      data: {},
    });

    dialogRef.afterClosed().subscribe((selectedProfiles: any[]) => {
      console.log("profili ", selectedProfiles);
      if (selectedProfiles && selectedProfiles.length) {
        selectedProfiles.forEach((profile) => {
          const exists = this.dataSource.some(
            (p) => p.profile === profile.name
          );
          if (!exists) {
            this.dataSource.push({
              profile: profile.name,
              read: false,
              create: false,
              update: false,
              decommission: false,
              mandatory: false,
            });
          }
        });

        this.dataSource.sort((a, b) => {
          if (a.profile === "Other profiles") return 1;
          if (b.profile === "Other profiles") return -1;
          return a.profile.localeCompare(b.profile);
        });

        this.dataSource = [...this.dataSource];
      }
    });
  }
}
